// components/WatchPurchaseGrid.js
import React from 'react';
import styles from './WatchPurchaseGrid.module.scss';
import {useNavigate} from "react-router-dom";

const WatchPurchaseGrid2 = () => {
  const watchBrands = [
    {
      name: "Zlatni nakit",
      image: "assets/images/lancic.webp",
      models: ["Ogrlice, narukvice, prstenje, minđuše, broševi..."]
    },
    {
      name: "Lomljeno zlato i neispravan nakit",
      image: "assets/images/lomljenozlato2.jpeg",
      models: [""]
    },
    {
      name: "Zlatne poluge i pločice",
      image: "assets/images/poluga.webp",
      models: [""]
    },
    {
      name: "Zlatne predmete",
      image: "assets/images/goldtray.jpg",
      models: ["Upaljači, pribor, satovi, futrole, okvir za naočare"]
    },
    {
      name: "Investiciono zlato i zlatne kolekcije",
      image: "assets/images/Investiciono-zlato-zlatana-poluga-Valcambi-1g.webp",
      models: [""]
    }
  ];

  const navigate = useNavigate();

  const handleClick = (brandName) => {
    const urlName = brandName.toLowerCase().replace(/\s+/g, "-"); // "Audemars Piguet" -> "audemars-piguet"
    window.location.href = `/brands/${urlName}`;
  };

  return (
    <section className={styles.watchPurchaseGrid}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>🥇 Zlato</h2>

        <div className={styles.grid}>
          {watchBrands.map((brand, index) => (
            <div key={index} className={styles.brandCard}>
              <div className={styles.brandHeader}>
                <h3>OTKUPLJUJEMO</h3>
                <h4>{brand.name}</h4>
                {/*<p>satova</p>*/}
              </div>

              <div className={styles.brandImage}>
                <img src={brand.image} alt={brand.name} />
              </div>

              <div className={styles.models}>
                {brand.models.map((model, idx) => (
                  (
                    idx === brand.models.length - 1 ?
                      <span>{model}</span>
                      :
                      <span>{model}, </span>
                  )
                ))}
              </div>

              <button className={styles.inquiryBtn} onClick={() => handleClick(brand.name)}>Saznaj više</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WatchPurchaseGrid2;